import React from 'react';
import { 
    LoadingIndicator, 
    UserMenu,
    useSidebarState,
    ToggleThemeButton 
} from 'react-admin';
import { 
    AppBar as MuiAppBar,
    Toolbar,
    IconButton, 
    Box,
    Typography,
    useTheme 
} from '@mui/material';
import { styled } from '@mui/material/styles';

// TODO: REFACTOR TO PROPER REACT ADMIN PATTERN
// Instead of using MuiAppBar directly, extend react-admin's AppBar component
// and override only the menu button using the 'toolbar' prop or theme customization.
// This would eliminate the need for Layout.js workarounds and position hacks.
// See: https://marmelab.com/react-admin/AppBar.html#customizing-the-appbar-content

// Custom styled component for the menu icon
const MenuIconButton = styled(IconButton)(({ theme }) => ({
    marginRight: theme.spacing(1),
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
}));

// Custom SVG Icon component
const VivCircleIcon = ({ ...props }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 350 350"
        fill="currentColor"
        {...props}
    >
        <circle cx="175" cy="175" r="175" fill="#eff4e5"/>
        <g>
            <polygon fill="#a59063" points="89.72 141.11 54.79 141.11 103.03 224.67 120.5 194.42 89.72 141.11"/>
            <polygon fill="#a59063" points="116.35 141.11 109.13 167.26 136.18 167.26 151.27 141.11 116.35 141.11"/>
            <polygon fill="#a59063" points="233.77 141.11 198.84 141.11 247.08 224.67 264.55 194.42 233.77 141.11"/>
            <polygon fill="#a59063" points="260.4 141.11 253.18 167.26 280.23 167.26 295.33 141.11 260.4 141.11"/>
            <rect fill="#a59063" x="159.43" y="141.11" width="31.14" height="83.56"/>
        </g>
    </svg>
);

const CustomAppBar = ({ ...props }) => {
    const theme = useTheme();
    const [sidebarOpen, setSidebarOpen] = useSidebarState();
    
    const handleMenuClick = React.useCallback(() => {
        setSidebarOpen(!sidebarOpen);
    }, [sidebarOpen, setSidebarOpen]);

    return (
        <MuiAppBar 
            position="static"
            color="secondary"
            enableColorOnDark
            elevation={1}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                marginTop: 0,
                ...props.sx
            }}
        >
            <Toolbar>
                {/* Custom Menu Button - ONLY our VIV logo */}
                <MenuIconButton
                    color="inherit"
                    onClick={handleMenuClick}
                    edge="start"
                    aria-label="Toggle navigation menu"
                    size="large"
                >
                    <VivCircleIcon />
                </MenuIconButton>

                {/* Fixed Title */}
                <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ 
                        flexGrow: 1,
                        marginLeft: 1,
                        color: 'inherit',
                        fontWeight: 500
                    }}
                >
                    ViV Wine and Spirits Client Desktop DEMO
                </Typography>

                {/* Loading Indicator */}
                <LoadingIndicator />
                {/* Theme Toggle Button */}
                <ToggleThemeButton />
                {/* User Menu */}
                <UserMenu />
            </Toolbar>
        </MuiAppBar>
    );
};

export default CustomAppBar;